export default __webpack_public_path__ + "static/apidetails-snapshot-7d0c503d49f5580d2d55664d8afa8863.jpg";